import YUSPUtil from '../../core/util/yusp_util';
import { ItemRepository } from '../../core/repositories/item_repository';
import { Item } from '../models/item';
import { JsEnv } from '../../core/models/js_env';
import { ItemJsEnv } from '../models/item_js_env';
import { TypedEvent } from '../../core/typed_event';
import { SubmitForm } from '../../core/actions/submit_form';
import { SupplierId } from '../../core/models/supplier_id';
import { AdobeAnalyticsData} from '../../core/models/analytics/adobe_analytics_data';
import { AddCartModalAction } from '../../core/actions/add_cart/modal_action';
import { AsCartItem } from '../../item/models/large_commercial_pack_env';
import { AnalyticsItemDisplayClick } from '../../core/models/analytics/analytics_Item_display_click';
import { RegularDeliveryAnalyticsData } from '../../core/models/analytics/regular_delivery_analytics_data';
import { ReviewButtonAnalyticsData } from '../../core/models/analytics/review_button_analytics_data';
import { AnalyticsItems } from '../../core/models/analytics/analytics_items';
import { AnalyticsItem } from '../../core/models/analytics/analytics_item';
import LazyUtil from '../../core/util/lazy_util';

export class ItemAction {
  static readonly UPDATE_EVENT = new TypedEvent<ItemJsEnv>();
  static readonly ADD_RECOMMENDATION_ITEM_EVENT = new TypedEvent<AnalyticsItems>();
  static readonly ADD_RECOMMENDATION_ITEM_FINISH_EVENT = new TypedEvent<AnalyticsItems>();
  static readonly WRITE_REVIEW_EVENT = new TypedEvent<ReviewButtonAnalyticsData>();
  static readonly RELATED_ITEM_EVENT = new TypedEvent<AdobeAnalyticsData>();
  static readonly CART_ADD_TOGETHER_EVENT = new TypedEvent<AnalyticsItems>();
  static readonly DISPLAY_PULLDOWN_BULK_PURCHASE_EVENT = new TypedEvent<AnalyticsItems>();
  static readonly VARIATION_LINK_EVENT = new TypedEvent<AnalyticsItems>();
  static readonly REGULAR_DELIVERY_EVENT = new TypedEvent<RegularDeliveryAnalyticsData>();
  static readonly NON_REGULAR_DELIVERY_EVENT = new TypedEvent<RegularDeliveryAnalyticsData>();
  static readonly ANALYTICS_ITEM_DISPLAY_CLICK_EVENT = new TypedEvent<AnalyticsItemDisplayClick>();
  static readonly ZOOM_IMAGE_EVENT = new TypedEvent<AnalyticsItemDisplayClick>();

  private static state: Item;
  private static itemRepository: ItemRepository;
  static init(env: JsEnv, containerClass: any) {
    this.state = new Item(env.PAGE);
    this.itemRepository = new ItemRepository();
    // YUSP連携 ユーザーID連携、VIEWイベント
    YUSPUtil.register({
      enableUserId: true,
      enableView: true,
    });
    // 外部ファイルにjsが含まれた場合、実行されるよう
    LazyUtil.enableExternalFileScript();
    return new containerClass(this.state.getModel());
  }

  // メッセージを表示する というアクション
  static showMessage(id: string) {
    const message = this.itemRepository.getMessage(id);
    this.state.updateMessage(message); // ItemJsEnvを操作する人に、メッセージの更新をお願いし、
    this.UPDATE_EVENT.trigger(this.state.getModel()); // item pageを更新するトリガをkick。
  }

  /// 商品詳細画像画像クリックのAdobe Analyticsトリガーを設定
  static itemImageDetailClickAnalytics(target: HTMLElement, index: number, length: number) {
    let item: AnalyticsItem = new AnalyticsItem();
    let supplierId = this.state.getModel().stockAreaJSOption.addressChoiceModel.supplierId;
    let caralogItemCode = this.state.getModel().stockAreaJSOption.addressChoiceModel.catalogItemCode;
    item._events = window.analyticsData.items[0].events;
    item._catalogItemCode = caralogItemCode;
    item._supplierId = new SupplierId(supplierId);
    item._medicalMaterialType = window.analyticsData.items[0].evars.eVar79;

    let analyticsItemDisplayClick: AnalyticsItemDisplayClick = {
      target: target,
      analyticsData: {
        item: item,
        length: length,
        index: index,
      },
    }

    this.ANALYTICS_ITEM_DISPLAY_CLICK_EVENT.trigger(analyticsItemDisplayClick);
  }

  static confirm() {
    // サンプルとして固定値を埋めているだけ
    SubmitForm.execute('item_form', { name: 'id', value: 'abc' });
  }

  static putTest() {
    this.itemRepository.putTest();
  }

  static getTest() {
    return this.itemRepository.getTest();
  }

  static postTest() {
    return this.itemRepository.postTest();
  }

  static deleteTest() {
    this.itemRepository.deleteTest();
  }

  static getErrorTest() {
    return this.itemRepository.getErrorTest();
  }

  /// レビューを書くボタン　計測
  static reviewButton(button, index, array) {
    let buttonSize = array.length;
    let analyticsData: ReviewButtonAnalyticsData = {
      analyticsData: {
        reviewButtonIndex: buttonSize > 1 ? index + 1 : null
      },
      target: button,
      linkName: 'ReviewWrite',
    }
    this.WRITE_REVIEW_EVENT.trigger(analyticsData);
  }

  /// おすすめの関連商品　AdobeAnalytics
  static relatedItem(e){
    let item = new AnalyticsItem();
    let analyticsData: AdobeAnalyticsData = {
      analyticsData: { items: item },
      target: e,
      linkName: 'RelatedItems'
    }
    this.RELATED_ITEM_EVENT.trigger(analyticsData);
  }

  /// 一緒にかごに入れる
  static cartAddTogether(buttonElm, checkedElm) {
    const items: any = [];
    const analyticsItems: Array<AnalyticsItem> = [];
    checkedElm.forEach((checkedItem) => {
      const catalogItemCode = checkedItem.getElementsByClassName("js-togetherItem-catalogItemCode")[0].value;
      const supplierId = checkedItem.getElementsByClassName("js-togetherItem-supplierId")[0].value;
      const medicalMaterialType = checkedItem.getElementsByClassName("js-togetherItem-medicalMaterialType")[0].value;

      const analyticsItem = new AnalyticsItem();
      analyticsItem._catalogItemCode = catalogItemCode;
      analyticsItem._supplierId = new SupplierId(supplierId);
      analyticsItem._medicalMaterialType = medicalMaterialType;
      analyticsItems.push(analyticsItem);

      items.push(new AsCartItem(supplierId, catalogItemCode, 1));
    });

    this.cartAddTogetherAnalytics(buttonElm, analyticsItems);

    AddCartModalAction.addCartTogether(buttonElm, '', '', items);
  }

  /// Adobe Analyticsトリガーを設定
  /// 一緒にかごに入れる押下時
  static cartAddTogetherAnalytics(target: HTMLElement, items: Array<AnalyticsItem>) {
    const analyticsData: AnalyticsItems = {
      analyticsData: { items: items },
      target: target,
      linkName: 'CartAddTogether'
    };
    this.CART_ADD_TOGETHER_EVENT.trigger(analyticsData);
  }

  /// Adobe Analyticsトリガーを設定
  /// 大業パまとめ買い設定用数量選択プルダウン押下時
  static displayPulldownBulkPurchaseAnalytics(target: HTMLElement) {
    const analyticsData: AnalyticsItems = {
      analyticsData: {
        items: []
      },
      target: target,
    };
    this.DISPLAY_PULLDOWN_BULK_PURCHASE_EVENT.trigger(analyticsData);
  }

  /// Adobe Analyticsトリガーを設定
  /// バリエーション一覧へリンク押下時
  static variationLinkAnalytics(target: HTMLElement) {
    const supplierId = (document.getElementById('supplierId') as HTMLInputElement).value;
    const catalogItemCode = (document.getElementById('catalogItemCode') as HTMLInputElement).value;
    const item = new AnalyticsItem();
    item._supplierId = new SupplierId(supplierId);
    item._catalogItemCode = catalogItemCode;
    const analyticsData: AnalyticsItems = {
      target: target,
      analyticsData: {
        items: [item]
      },
    };
    this.VARIATION_LINK_EVENT.trigger(analyticsData);
  }

  /// Adobe Analyticsトリガーを設定
  /// 通常商品⇔定期配送切替
  static regularDeliveryAnalytics(target: HTMLElement, isRegularDelivery: boolean) {
    const item = new AnalyticsItem();
    const model: ItemJsEnv = this.state.getModel();
    const analyticsData: RegularDeliveryAnalyticsData = {
      items: [item],
      target: target,
      isLogin: model.isLogin
    };

    if (isRegularDelivery) {
      /// 通常商品⇒定期配送
      this.REGULAR_DELIVERY_EVENT.trigger(analyticsData);
    } else {
      /// 定期配送⇒通常商品
      this.NON_REGULAR_DELIVERY_EVENT.trigger(analyticsData);
    }
  }

  /// AdobeAnalyticsトリガーを設定
  /// 商品詳細・商品拡大表示モーダル内の画像押下時
  static MoadlAdobeAnalytics(e, index, array) {
    const item = new AnalyticsItem();
    const supplierId = this.state.getModel().stockAreaJSOption.addressChoiceModel.supplierId;
    const caralogItemCode = this.state.getModel().stockAreaJSOption.addressChoiceModel.catalogItemCode;
    item._events = window.analyticsData.items[0].events;
    item._catalogItemCode = caralogItemCode;
    item._supplierId = new SupplierId(supplierId);
    item._medicalMaterialType = window.analyticsData.items[0].evars.eVar79;
    const analyticsData: AnalyticsItemDisplayClick = {
      analyticsData: {
        item: item,
        length: array.length,
        index: index + 1
      },
      target: e,
      linkName: 'ClkChangeProdImage',
    };
    this.ZOOM_IMAGE_EVENT.trigger(analyticsData);
  }
}
